import React, { useState, useEffect } from "react";
import { FaGlobe } from "react-icons/fa";
import { i18n } from "../../translate/i18n";
import useSettings from "../../hooks/useSettings";

const LANGUAGE_OPTIONS = [
  { code: "pt-BR", label: "Português" },
  { code: "en", label: "English" },
  { code: "es", label: "Spanish" },
  { code: "ar", label: "عربي" }
];

/** Seletor de idioma (navbar) — dropdown com as línguas habilitadas. */
const LanguageSwitcher = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [enabledLanguages, setEnabledLanguages] = useState(["pt-BR", "en"]);
  const { getAll } = useSettings();

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const settings = await getAll();
        const raw = settings.find(s => s.key === "enabledLanguages")?.value;
        let langs = ["pt-BR", "en"];
        try {
          if (raw) langs = JSON.parse(raw);
        } catch { /* mantém default */ }
        if (active) setEnabledLanguages(langs);
      } catch { /* mantém default */ }
    })();
    return () => {
      active = false;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLanguageChange = lng => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
    window.location.reload();
  };

  const options = LANGUAGE_OPTIONS.filter(l => enabledLanguages.includes(l.code));

  return (
    <div
      style={{ position: "relative", display: "inline-block" }}
      className="language-dropdown"
    >
      <button
        onClick={() => setShowOptions(!showOptions)}
        style={{
          background: "none",
          border: "none",
          color: "white",
          cursor: "pointer",
          fontSize: "22px",
          paddingRight: "20px",
          paddingTop: "8px"
        }}
      >
        <FaGlobe />
      </button>

      {showOptions && (
        <div
          style={{
            position: "absolute",
            top: "35px",
            left: "0",
            background: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            borderRadius: "8px",
            padding: "8px",
            zIndex: 1000,
            minWidth: "120px",
            maxWidth: "200px"
          }}
        >
          {options.map(lang => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "block",
                width: "100%",
                padding: "4px"
              }}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};


export default LanguageSwitcher;
